import React from 'react';

import './IncorrectInputModal.css'


const IncorrectInputModal = ({ message, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className='modal-page'>
            <div className='modal-title'>
              <h3>{message}</h3>
            </div>
          <button onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default IncorrectInputModal;